import { useFormikContext } from "formik";
import { formatMoney, metaobject, sectionSettings, translations } from "../../Helpers/WindowHelpers";
import { updateVariantObject } from "../../Helpers/FormikUpdateFunctions";
import Select from "../Fields/Select";
import Heading from "../Heading";
import Message from "../Fields/Message";

interface SkirtAndStrapLengthsInterface {

}

const SkirtAndStrapLengths = ({ }: SkirtAndStrapLengthsInterface) => {
    const context = useFormikContext<any>();
    const defaultSkirtLengthId = context.values.skirt_length?.variantId;
    const updateSkirtLength = (value: string) => {
        const variant = metaobject.skirt_length_options.find((item) => item.id == value);
        updateVariantObject('skirt_length', variant, context, 3);
    }

    const updateStrapLength = (value: string) => {
        const variant = metaobject.strap_length_options.find((item) => item.id == value);
        updateVariantObject('strap_length', variant, context, 3);
    }
    return (
        <>
            {sectionSettings.heading_straps && (sectionSettings.straps_info || metaobject.strap_length_options.length > 0) ?
                <Heading
                    level={4}
                    text={sectionSettings.heading_straps}
                    classes="d--flex flex-column gap-5"
                    ></Heading>
                : null}
            {sectionSettings.straps_info ?
                <Message message={sectionSettings.straps_info} isWarning={true} />
                : null}
            {metaobject.strap_length_options.length > 0 ? (
                <Select
                    name={'strap_length.variantId'}
                    label={sectionSettings.label_strap_length}
                    defaultValue={context.values.strap_length?.variantId}
                    defaultText={sectionSettings.label_strap_length_select}
                    disabled={!context.values?.strap_location && !metaobject.rolling_covers}
                    options={metaobject.strap_length_options.map((length) => {
                        return {
                            text: `${length.title}${parseInt(length.price) > 0 ? ` (+${formatMoney(length.price)})` : ''}`,
                            value: length.id
                        }
                    })}
                    onChange={updateStrapLength}
                >
                </Select>
            ) : null}
            {metaobject.skirt_length_options.length > 0 ? (
                <>
                    {sectionSettings.heading_skirt ?
                        <Heading
                            level={4}
                            text={sectionSettings.heading_skirt}
                            classes="d--flex flex-column gap-5"
                            ></Heading>
                        : null}
                    <Select
                        name={'skirt_length.variantId'}
                        label={sectionSettings.label_skirt_length}
                        defaultValue={defaultSkirtLengthId}
                        defaultText={sectionSettings.label_skirt_length_select}
                        options={metaobject.skirt_length_options.map((length) => {
                            var savings = (length.compare_at_price > length.price) ? `, ${translations.save} ${Math.floor((1 - (length.price / length.compare_at_price)) * 100)}%` : '';
                            return {
                                text: `${length.title}${parseInt(length.price) > 0 ? ` (+${formatMoney(length.price)}${savings})` : ''}`,
                                value: length.id
                            }
                        })}
                        onChange={updateSkirtLength}
                    >
                    </Select>
                </>
            ) : null}
        </>)
}

export default SkirtAndStrapLengths;